<template>
  <div>
    <b-dropdown ref="column-dropdown" :open.sync="visibilityOpen" @mouseleave.native="hideOnMouseLeave">
      <a class="button" slot="trigger">
          <span><translate>list.spaltensichtbarkeit</translate></span>
          <b-icon type="is-aquamarine" icon="angle-down"></b-icon>
      </a>
      <div v-for="column in value" :key="column.key || column.field">
          <!-- only class 'dropdown-item' instead of b-dropdown-item to prevent closing on click -->
          <b-field class="dropdown-item">
            <b-checkbox @input="emitChange" v-model="column.tableVisible">
              <translate>{{ column.label }}</translate>
            </b-checkbox>
          </b-field>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchOpen: false,
      visibilityOpen: false
    }
  },
  props: ['value'],
  methods: {
    emitChange () {
      this.$emit('input', this.value)
    },
    hideOnMouseLeave () {
      let el = this.$refs['column-dropdown']
      if (el.isActive) {
        el.toggle()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/EntityListColumnVisibility.vue